const wrapAroundValue = (val: number, max: number) => ((val % max) + max) % max;

const hardBoundedValue = (val: number, max: number) =>
  Math.max(0, Math.min(max, val));

export const normalizeIndex = (idx: number, len: number, wrap = false) =>
  wrap ? wrapAroundValue(idx, len) : hardBoundedValue(idx, len - 1);

export const nop = () => {};

export const easeOutQuint = (t: number) => {
  let n = t;
  return 1 + --n * n ** 4;
};

const fakeChild = {
  getBoundingClientRect: () => ({ left: -Infinity, right: -Infinity }),
};
export const isWhollyInView =
  (parent: HTMLElement) =>
  (child = fakeChild) => {
    const { left: childLeft, right: childRight } =
      child.getBoundingClientRect();
    const { left: parentLeft, right: parentRight } =
      parent.getBoundingClientRect();
    // 5px threshold
    return childLeft >= parentLeft - 5 && childRight <= parentRight + 5;
  };

export const animate = (
  el: HTMLElement,
  {
    delta = 0,
    immediate = false,
    duration = 500,
    easing = easeOutQuint,
    prop = 'scrollTop',
  }: {
    delta?: number;
    immediate?: boolean;
    duration?: number;
    easing?: (t: number) => number;
    prop?: 'scrollTop' | 'scrollLeft';
  },
) =>
  new Promise<void>(res => {
    if (!delta) {
      return res();
    }
    const initialVal = el[prop];
    if (immediate) {
      el[prop] = initialVal + delta;
      return res();
    }
    let startTime: number;
    const step = (timestamp: number) => {
      if (!startTime) {
        startTime = timestamp;
      }
      const progressTime = timestamp - startTime;
      const progressRatio = easing(progressTime / duration);
      el[prop] = initialVal + delta * progressRatio;
      if (progressTime < duration) {
        window.requestAnimationFrame(step);
      } else {
        el[prop] = initialVal + delta;
        res();
      }
    };
    window.requestAnimationFrame(step);
  });
